import React, {Component} from 'react';
import {Header, Grid, Container} from 'semantic-ui-react';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import OrgUsersCardContainer from './orgUsersCard/orgUsersCardContainer';
export class Team extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Main>
        <Container>
          <OrgUsersCardContainer userId={this.props.id} token={this.props.token} />
        </Container>
      </Main>
    );
  }
}

export default Team;
